// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1UserCapacitySchema } from './v1/userCapacitySchema';

export const listUserCapacitiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  user_id: z.number().int().describe("User ID"),
});

export const listUserCapacitiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description User's capacities retrieved successfully
 */
export const listUserCapacities200Schema = z.array(z.lazy(() => v1UserCapacitySchema));

/**
 * @description Unauthorized
 */
export const listUserCapacities401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listUserCapacitiesQueryResponseSchema = z.lazy(() => listUserCapacities200Schema);
